window.addEventListener('DOMContentLoaded', () => {

  blogCampaignMainWrapper();

  function blogCampaignMainWrapper(){

    const blogPostBannerItem = document.getElementsByClassName("blog-post__banner-item");

    // ---- Init on load Pagination
    initAjaxifiedPagination();

    function initAjaxifiedPagination(){
      // initial number of banners shown
      for(let i=4; i<blogPostBannerItem.length; i++){
        blogPostBannerItem[i].style.display = "none";
      }
    }

    // ---- Pagination logic
    // set banner to start from
    let pagCounter = 4;

    function triggerAjaxifiedPagination(){
        if(blogPostBannerItem[pagCounter]){
          blogPostBannerItem[pagCounter].style.display = "flex";
        }
        if(!blogPostBannerItem[pagCounter]){
          return;
        }
    }

    // ---- Viewport logic
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    // ---- Viewport Trigger
    const footer = document.querySelector('.campaign-pagination-limit-bar');
    
    document.addEventListener('scroll', function () {
        const theScrollState = isInViewport(footer);

        // if footer in viewport
        if(theScrollState){
          triggerAjaxifiedPagination();
          // x number of banners
          pagCounter += 1;
        }
    },{
        passive: true
    });

    // ----- scroll to next slide
    document.addEventListener('click',function(eventClicked){
      if(eventClicked.target.getAttribute("banner-item-next-button") == "banner-item-next-button"){
        let parentBanner = eventClicked.target.parentNode.parentNode.parentNode.nextElementSibling;

        if(parentBanner.style.display = "none"){
          parentBanner.style.display = "flex";
        }

        parentBanner.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
    // ----
    
  }

});